import React from 'react';
import SingleTerm from "./SingleTerm";
import TermGroup from "./TermGroup";
import {Term} from "./interfaces";

interface TermsRenderProps {
  terms: Term[]
}

export type TermsRenderComponent = (props: TermsRenderProps) => JSX.Element;

const TermsRender: TermsRenderComponent = ({terms}) => {
  const TermGroupRender: Function = (): JSX.Element[] => {
    return terms.map((currentTerm: Term) => {
      if (currentTerm.items.length === 0) {
        return <SingleTerm term={currentTerm} key={`term_id:${currentTerm.id}`}/>
      }
      return <TermGroup term={currentTerm} key={`term_group_id:${currentTerm.id}`}/>
    });
  }

  return <TermGroupRender />;
}

export default TermsRender;
